import { Constants } from '../Constants';

let Constant = Constants.getInstance();

export class ServiceHealthHelper {
  public static getStatusIconOuter(serviceStatus: string): string {
    let iconClass = 'win-icon serviceHealthTableIconSize win-icon-StatusCircleOuter win-color-fg-green';

    switch (serviceStatus) {
      case Constant.HealthStatus.Error:
        iconClass = 'win-icon serviceHealthTableIconSize win-icon-StatusCircleOuter win-color-fg-red';
        break;
      case Constant.HealthStatus.Warning:
        iconClass = 'win-icon serviceHealthTableIconSize win-icon-StatusTriangleOuter win-color-fg-yellow';
        break;
      case Constant.HealthStatus.Information:
        iconClass = 'win-icon serviceHealthTableIconSize win-icon-StatusCircleOuter win-color-fg-blue';
        break;
    }

    return iconClass;
  }

  public static getStatusIconInner(serviceStatus: string): string {
    let iconClass = 'win-icon serviceHealthTableIconSize win-color-fg-primary color-alt win-icon-StatusCircleCheckmark';

    switch (serviceStatus) {
      case Constant.HealthStatus.Error:
        iconClass = 'win-icon serviceHealthTableIconSize win-color-fg-primary color-alt win-icon-StatusCircleErrorX';
        break;
      case Constant.HealthStatus.Warning:
        iconClass = 'win-icon serviceHealthTableIconSize win-icon-StatusTriangleExclamation';
        break;
      case Constant.HealthStatus.Information:
        iconClass = 'win-icon serviceHealthTableIconSize win-color-fg-primary color-alt win-icon-StatusCircleInfo';
        break;
    }

    return iconClass;
  }
}
